import React, {Component} from 'react'
import {Button, Feed, Modal} from 'semantic-ui-react'

export default class PlayerStatsModal extends Component {

    state = {};

    render() {
        return (
            <Modal
                open={!!this.props.player}
                size='medium'
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                {this.props.player && <Modal.Header icon='users'
                                                    content={`Øl-historikk - ${this.props.player.name} (${sumEntries(this.props.player.beerHistoryEntries)} øl)`}/>}
                <Modal.Content>
                    <Feed>
                        {this.props.player && this.props.player.beerHistoryEntries.map((entry, i) =>
                            <Feed.Event key={entry.time}>
                                <Feed.Content>
                                    <Feed.Summary>
                                        {`${entry.time ? new Date(entry.time).toLocaleDateString() : 'Start'} - ${mapReason(entry)} (${entry.beerPunishment} øl), totalt ${sumEntries(this.props.player.beerHistoryEntries.slice(0, i + 1))}`}
                                    </Feed.Summary>
                                </Feed.Content>
                            </Feed.Event>
                        )}
                    </Feed>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.props.close} content='Lukk'/>
                </Modal.Actions>
            </Modal>)
    }
}

const sumEntries = (entries) => entries.reduce((acc, cur) => acc + cur.beerPunishment, 0)

const mapReason = (entry) => {
    switch (entry.reason) {
        case "LONG_TERM_DEREGISTER":
            return "Langtidsavmelding";
        case "LATE_RESPONSE":
            return "Sent svar";
        case "NO_RESPONSE":
            return "Manglende svar";
        case "REMOVED":
            return "Innfridd øl" + (entry.comment ? `, ${entry.comment}` : "");
        case "AT_START":
            return "Ved oppstart";
        default:
            return "Ukjent";
    }
}



// WEBPACK FOOTER //
// ./src/Components/PlayerStatsModal.js